// extracted by mini-css-extract-plugin
module.exports = {"sfc_slider":"Index_sfc_slider__NGZR8","inputNumber":"Index_inputNumber__Z9Wst","switch":"Index_switch__spPnt","paymentType":"Index_paymentType__zw0XW"};